var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio-builder"},[_c('b-card',[_c('WizardProgress',{attrs:{"steps":_vm.steps}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }